<template>
  <v-dialog
    ref="dialog"
    v-model="modal"
    :return-value.sync="time"
    persistent
    width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-btn text v-on="on" small
        ><v-icon left small>access_time</v-icon>
        {{ time != "" ? time : "Set Time" }}</v-btn
      >
    </template>
    <v-time-picker v-if="modal" v-model="time" full-width>
      <v-spacer></v-spacer>
      <v-btn text color="primary" @click="modal = false">Cancel</v-btn>
      <v-btn text color="primary" @click="onSave">OK</v-btn>
    </v-time-picker>
  </v-dialog>
</template>

<script>
export default {
  name: "time-label",

  props: {
    value: {
      type: String,
      default: () => "",
    },
  },

  data() {
    return {
      debug: false,
      modal: false,
      time: this.value && this.value != "" ? this.value : "",
    };
  },

  methods: {
    onSave() {
      this.$refs.dialog.save(this.time);
      this.$emit("input", this.time);
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/shared/labels/TimeLabel.vue